import { render, staticRenderFns } from "./login_form.vue?vue&type=template&id=1b603008&scoped=true"
import script from "./login_form.vue?vue&type=script&lang=ts"
export * from "./login_form.vue?vue&type=script&lang=ts"
import style0 from "./login_form.vue?vue&type=style&index=0&id=1b603008&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b603008",
  null
  
)

export default component.exports